import { render } from "./ButtonPagination.vue?vue&type=template&id=00147966&scoped=true"
import script from "./ButtonPagination.vue?vue&type=script&lang=js"
export * from "./ButtonPagination.vue?vue&type=script&lang=js"

import "./ButtonPagination.vue?vue&type=style&index=0&id=00147966&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00147966"]])

export default __exports__